import { ButtonType, ButtonWidget, TextLinkWidget } from '@tableau/widgets';

import { Messages } from '../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { ServerSettingsInstance } from '../../settings/services/ServerSettings';
import { StartPageService } from '../../settings/services/StartPageService';
import { IEditableServerSettings } from '../../ts/ServerApi/types/IEditableServerSettings';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import showResetStartPageDialog from '../services/ResetStartPage';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import React = require('react');
import { ISiteAdminSettings, ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { Sites } from '~src/ts/siteManagement/services/resources/Sites';

export type StartPageSettingProps = {
  startPage: string;
  isViewerSelf: boolean;
  isViewerAdmin: boolean;
  sessionSiteUrlName: string;
  serverUser: IServerUserInfo;
  isServerUserSubplace: boolean;
}


export function StartPageSetting(props: StartPageSettingProps): JSX.Element {
  const [sanitizedStartPage, setSanitizedStartPage] = React.useState<string>('');
  const [startPageHref, setStartPageHref] = React.useState<string>('');

  React.useEffect(
    () => {
      if (!props.startPage) {
        if (props.isViewerAdmin && props.isServerUserSubplace) {
          ServerSettingsInstance.fetch()
          .then((result: IEditableServerSettings) => {
            let startPage = result.defaultStartPage || '/';
            setSanitizedStartPage(startPage);
            setStartPageHref(StartPageService.getStartPageForSite(startPage, props.sessionSiteUrlName));
          });
        } else if (props.isViewerAdmin && !props.isServerUserSubplace) {
          Sites.instance.getCurrentSiteSettingsForSiteAdmin()
          .then((result: ISiteSettingsForSiteAdmin) => {
            let siteAdminSettings = result.siteAdminSettings as ISiteAdminSettings;
            let startPage = siteAdminSettings.siteStartPageUri;
            setSanitizedStartPage(startPage);
            setStartPageHref(StartPageService.getStartPageForSite(startPage, props.sessionSiteUrlName));
          });
        } else {
          let startPage = getSessionManagementServiceInstance().getStartPage();
          setSanitizedStartPage(startPage);
          setStartPageHref(StartPageService.getStartPageForSite(startPage, props.sessionSiteUrlName));
        }
      } else {
        setSanitizedStartPage(props.startPage);
        setStartPageHref(StartPageService.getStartPageForSite(props.startPage, props.sessionSiteUrlName));
      }
    },
    [props.startPage, props.sessionSiteUrlName, props.isViewerAdmin, props.isServerUserSubplace]
  );
  return (
    <table>
      <tbody className={UserSettingsStyle.tbody} >
        <tr data-tb-test-id="start-page-setting">
          <td className={UserSettingsStyle.labelText}>
            {Messages.settings_startPage_title()}
            </td>
            <td className={UserSettingsStyle.detailsValue}>
              {
                props.isViewerSelf && getHint(props.isViewerAdmin)
              }
            </td>
          </tr>
        <tr data-tb-test-id="start-page-description">
        <td className={UserSettingsStyle.labelText}></td>
            <td className={UserSettingsStyle.detailsValue}>
            <span>{Messages.settings_startPage_current_start_page()}</span>
            <span>
            <TextLinkWidget
            href={'#' + startPageHref}
            testId={'start-page-link'}
            children={sanitizedStartPage}
            target='_blank'/>
            {!props.startPage && Messages.reserStartPage_default()}
            </span>
            <span>&nbsp;&nbsp;</span>
            <span>
              <ButtonWidget
              buttonType={ButtonType.Outline}
              testId='reset-to-default-start-page'
              disabled={!startPageHref || !props.startPage}
              onClick={() => showResetStartPageDialog(props.serverUser)}
              children={Messages.resetStartPage_button()}
              />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
  );
}

function getHint(isViewerAdmin: boolean) {
  const message = isViewerAdmin? Messages.startPageHint_admin(): Messages.startPageHint_user();
  return(
    <div data-tb-test-id = "start-page-hint">
      {message}
    </div>
  );
}
